import { Link, NavLink, useParams } from 'react-router-dom';
import { policyLinks } from './policyLinks';
import { useLangTranslation } from '../utils/translation';
export default function Footer(){
 const {lang='en'}=useParams();const t=useLangTranslation('common');
 return <footer className="edge-footer"><div className="footer-inner">
  <div className="footer-brand-row"><div><Link to={`/${lang}`} aria-label="EDGE"><img src="/assets/logo-white.svg" alt="EDGE"/></Link><p>Independent minds. Shared play.</p></div><a className="footer-contact-link" href="mailto:help.edge@gmail.com">{t('footer.contactLabel')} ↗<span>help.edge@gmail.com</span></a></div>
  <div className="footer-detail-grid"><div className="footer-company"><p>{t('footer.company.name')}</p><p>{t('footer.company.representative')}</p><p>{t('footer.company.businessNumber')}</p></div><nav className="footer-links" aria-label={t('footer.policyLabel')}>
  {policyLinks.map(([path,key])=><NavLink key={path} end to={`/${lang}/${path}`}>{t(`footer.policies.${key}`)}</NavLink>)}
</nav></div>
  <div className="footer-bottom"><p>© {new Date().getFullYear()} EDGE. All rights reserved.</p></div>
 </div></footer>;
}
